import styles from "./navigationBar.module.scss";
import Logo from "../../assets/images/logo.svg";
import { selectUser, selectAccount } from "../../app/appSlice";
import { useSelector } from "react-redux";
import { Menu, MenuItem } from "@szhsin/react-menu";
import msalInstance from "../../app/msal";
import { useMsal } from "@azure/msal-react";
import downArrow from "../../assets/images/arrow_down.svg";
import { Link } from "react-router-dom";
import constants from "../../utilities/constants";

const NavigationBar = () => {
  const user = useSelector(selectUser);
  const { accounts } = useMsal();
  const userRole = user.roles.map(
    (role) => role[0].toUpperCase() + role.substring(1)
  );

  // Check if user is admin
  const isAdmin = user?.roles?.includes(constants.userRoles.admin);

  return (
    <>
      <header className={styles.header}>
        <div className={styles.navBar}>
        <div className={styles.leftSection}>
            <div className={styles.logo}>
              <a href="/">
                <img src={Logo} alt="daikin-logo"></img>
              </a>
            </div>

            <div className={styles.navigationLinks}>
              <div className={styles.navigationLinkItem}>
                <Link to="/dashboard">Dashboard</Link>
              </div>
              <div className={styles.navigationLinkItem}>
                <Link to="/products">Products</Link>
              </div>
              {isAdmin && (
                <div className={styles.navigationLinkItem}>
                  <Link to="/user-management">User Management</Link>
                </div>
              )}
              <div className={styles.navigationLinkItem}>
                <Link to="/about">About</Link>
              </div>
            </div>
          </div>
          
          <div className={styles.user}>
            <div>
              <div className={styles.userName}>{user.name}</div>
              <div className={styles.userRole}>{userRole}</div>
            </div>
            <div>
              <Menu
                menuButton={
                  <div>
                    <img src={downArrow} alt="down-arrow"></img>
                  </div>
                }
                transition
              >
                <MenuItem
                  onClick={async () => {
                    if (accounts.length > 0) {
                      await msalInstance.logoutRedirect({
                        logoutHint: accounts[0].idTokenClaims.login_hint,
                      });
                    }
                  }}
                >
                  Logout
                </MenuItem>
              </Menu>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
export default NavigationBar;
